import { Box, Button, Typography } from '@mui/material';
import { t } from 'i18next';
import NoteForm from './NoteForm';
import { Icon } from '@sdb/planning-ui';

const NotesBar = ({
  requestId,
  showNotes,
  setShowNotes,
  showNoteForm,
  setShowNoteForm,
  notes
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={1} width={1}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1.75}
      >
        <Box display="flex" gap={2}>
          <Button
            onClick={() => {
              setShowNotes(!showNotes);
              showNotes && setShowNoteForm(false);
            }}
            color="primary"
            size="small"
            variant="text"
            sx={{ display: 'flex', gap: 1, textTransform: 'none' }}
          >
            <Typography variant="h6" component="h4">
              {t('notes')} ({notes?.length})
            </Typography>
            {showNotes ? (
              <Icon type="chevron-up" fontSize="inherit" color="inherit" />
            ) : (
              <Icon type="chevron-down" fontSize="inherit" color="inherit" />
            )}
          </Button>
        </Box>
        <Button
          onClick={() => {
            setShowNoteForm(!showNoteForm);
            !showNotes && setShowNotes(true);
          }}
          color="primary"
          size="small"
          variant="outlined"
          sx={{ display: 'flex', width: 'max-content', gap: 1 }}
        >
          {showNoteForm ? (
            <>{t('cancel')}</>
          ) : (
            <>
              <Icon type="plus" fontSize="inherit" color="primary" />
              {t('addNote')}
            </>
          )}
        </Button>
      </Box>
      {showNoteForm && (
        <NoteForm requestId={requestId} setShowNoteForm={setShowNoteForm} />
      )}
    </Box>
  );
};

export default NotesBar;
